import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Input from 'components/Material/Input';
import Select from 'components/Material/Select';

import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { userTypeList, localeTw, isTypeBK, isType } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import { deleteItem, postSearch, snackBarRsp } from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import {
  ColDef,
  GridOptions,
  ICellRendererComp,
  ICellRendererFunc,
  ICellRendererParams,
} from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Refresh';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';

import { Autocomplete } from '@material-ui/lab';
import { TextField, Theme, createStyles, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { escapeLeadingUnderscores } from 'typescript';
import Header from 'components/Header';
import {
  getDateDayPlus,
  getFindDropDownList,
  getfindDropDownContainerNoList,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster, ICRUDDetail, ICRUD } from './type';
import MedalCellRenderer from './ImageRender';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);

/** 貨物拆櫃預定表維護作業(海關) */
const OpenCtnrImgMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'openCtnrImgMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');
  const [openCNStatOptions, setOpenCNStatOptions] = useState<Ioption[]>([]);
  const [containerNoList, setContainerNoList] = useState<string[]>([]);
  const [enableDelete, setEnableDelete] = useState<boolean>(false);
  const [showImage, setShowImage] = useState('');

  const [rowData2, setRowData2] = useState<ICRUDDetail[]>([]);
  const [photo, setPhoto] = useState('');
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [images, setImages] = useState<string[]>([]);

  const masterDefaultValue: Imaster = {
    // 貨棧業者
    warehouse:
      userType === userTypeList.type1[0] ||
      userType === userTypeList.type6[0] ||
      userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    // 拆櫃日期
    declDate: getDateDayPlus(),
    // 貨櫃號碼
    containerNo: '',
    // 開櫃狀態
    openCtnrStatus: '',

    declDateValid: true,
    warehouseValid: true,

    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type6, userType) ||
        isType(userTypeList.topType, userType) ||
        isType(userTypeList.type4, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);
  useEffect(() => {
    if (master.warehouse && master.warehouse.length > 0) {
      getFindDropDownList('findDropDownOpenCNStat', {
        warehouse: locationCode,
      }).then((item) => {
        setOpenCNStatOptions(item);
      });
      getfindDropDownContainerNoList(
        master.declDate,
        master.warehouse,
        ''
      ).then((item) => {
        setContainerNoList(item);
      });
    }
  }, [master.warehouse]);

  useEffect(() => {
    if (master.declDate && master.declDate.length > 0) {
      getfindDropDownContainerNoList(
        master.declDate,
        master.warehouse,
        ''
      ).then((item) => {
        setContainerNoList(item);
        console.log('item', item);
      });
    }
  }, [master.declDate]);

  const ImageCellRenderer = (props: any): string => {
    // const { value, ...other } = props;
    // console.log('props', props);

    // const history = useHistory();
    // const openImage = () => {
    //   if (value) {
    //     setShowImage(value);
    //   }
    // };
    // const invokeParentMethod = () => {
    //   props.context.methodFromParent(
    //     `Row: ${props.node.rowIndex}, Col: ${props.colDef?.field}`
    //   );
    // };
    const test = document.createElement('div');
    return '';
  };

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '貨櫃號碼',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '開櫃狀態',
        field: 'openCtnrStatus',
        width: 300,
      },

      {
        field: 'imageSrc',
        headerName: '圖檔(點擊另開)',
        width: 300,
        cellRenderer: MedalCellRenderer,
      },
      {
        headerName: '備註',
        field: 'remark',
        width: 300,
      },
      {
        headerName: '上傳時間',
        field: 'insertDate',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        width: 300,
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 150,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      warehouse: master.warehouse,
      declDate: master.declDate,
      containerNo: master.containerNo,
      openCtnrStatus: master.openCtnrStatus,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const openCtnrImgMtnList = result.data.data as Iresult[];

    if (openCtnrImgMtnList && (openCtnrImgMtnList || []).length > 0) {
      setRowData(openCtnrImgMtnList);
      setOpenSearchTable(true);
      setEnableDelete(true);
    } else {
      setOpenSearchTable(false);
      setEnableDelete(false);
    }
    setRandomValue(Math.random());
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const rowDataCRUD: ICRUDDetail[] = [];

    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      selectedDatas.forEach((node: any) => {
        const itemDataCRUD: ICRUDDetail = {
          rownum: node.data.rownum,
          containerNo: node.data.containerNo,
          openCtnrStatus: node.data.openCtnrStatus,
          imageFile: node.data.imageFile,
          imageSrc: node.data.imageSrc,
          remark: node.data.remark,
          insertDate: node.data.insertDate,
        };
        return rowDataCRUD.push(itemDataCRUD);
      });
    } else {
      enqueueSnackbar('請先選擇資料');
      return;
    }

    const DataCRUD: ICRUD = {
      openCtnrImgMtnListDTOs: rowDataCRUD,
      warehouse: master.warehouse,
      declDate: master.declDate,
      containerNo: master.containerNo,
      openCtnrStatus: master.openCtnrStatus,
    };
    const result = await deleteItem(apiName, DataCRUD);
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const data = result.data.data as Iresult[];

    if ((data || []).length > 0) {
      setEnableDelete(false);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableDelete(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }

    if (!master.declDateValid || !master.warehouseValid) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
  };

  const handleReset = async () => {
    setMaster(masterDefaultValue);
    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    // setPhoto('');
    // setUploadFile(null);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const handleReset2 = async () => {
    // const [rowData2, setRowData2] = useState<Iresult[]>([]);
    const list: ICRUDDetail[] = [
      {
        rownum: 'RI',
        containerNo: '1',
        openCtnrStatus: '2',
        imageSrc: `data:image/jpg;base64,${photo}`,
        imageFile: ``,
        remark: '5',
        insertDate: '',
      },
      {
        rownum: 'NM',
        containerNo: '6',
        openCtnrStatus: '7',
        imageSrc: `data:image/jpg;base64,${photo}`,
        imageFile: ``,
        remark: '10',
        insertDate: '',
      },
      {
        rownum: 'ND',
        containerNo: '11',
        openCtnrStatus: '12',
        imageSrc: `data:image/jpg;base64,${photo}`,
        imageFile: ``,
        remark: '15',
        insertDate: '',
      },
      {
        rownum: 'NC',
        containerNo: '16',
        openCtnrStatus: '17',
        imageSrc: `data:image/jpg;base64,${photo}`,
        imageFile: ``,
        remark: '20',
        insertDate: '',
      },
      {
        rownum: 'NB',
        containerNo: '21',
        openCtnrStatus: '22',
        imageSrc: `data:image/jpg;base64,${photo}`,
        imageFile: ``,
        remark: '25',
        insertDate: '',
      },
    ];
    // console.log('photo', photo);
    // console.log('photo[0]', photo[0]);
    // console.log('list', list);
    if (list && (list || []).length > 0) {
      setRowData2(list);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
  };

  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案
    const reader = new FileReader();
    let fileBase64 = '';
    if (file) {
      setMaster({ ...master, fileName: file.name });
      reader.readAsArrayBuffer(file);
      reader.onloadend = (evt) => {
        if (evt?.target?.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result;
          const array = new Uint8Array(arrayBuffer as ArrayBuffer);
          for (let i = 0; i < array.length; i += 1) {
            fileBase64 += String.fromCharCode(array[i]);
          }
          setPhoto(btoa(fileBase64));
          setImages((prevPhoto) => [...prevPhoto, btoa(fileBase64)]);
        }
      };
      setUploadFile(file);
    }
    e.target.value = '';
  };

  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 開櫃影像查詢作業
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[
                  ...userTypeList.type2,
                  ...userTypeList.type1,
                  ...userTypeList.type6,
                ].indexOf(userType) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*通關日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              貨櫃號碼：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                inputValue={master.containerNo}
                onInputChange={(event, newInputValue) => {
                  setMaster((prev) => ({
                    ...prev,
                    containerNo: newInputValue,
                  }));
                }}
                options={containerNoList}
                renderInput={(params) => <TextField {...params} label="" />}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>開櫃狀態：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.openCtnrStatus}
                onChange={selectChange(updateData)}
                name="openCtnrStatus"
                options={openCNStatOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={!enableDelete || formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<DeleteIcon />}
              onClick={() => setSubmitKey('deleteItem')}
            >
              刪除
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          {/* <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset2()}
            >
              重置2
            </Button>

            <Grid item xs={12} sm="auto">
              <input
                disabled={formError}
                accept=".jpg,.jpeg,.gif,.png"
                className={classes.input}
                id="contained-button-file"
                // multiple
                type="file"
                onChange={selectFile}
                capture="camera"
              />
              <label htmlFor="contained-button-file">
                <Button
                  disabled={false}
                  variant="contained"
                  color="default"
                  startIcon={<RefreshIcon />}
                  component="span"
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: 'blue',
                  }}
                >
                  選擇圖片
                </Button>
              </label>
            </Grid>
          </Grid> */}
        </Grid>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              全選
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              全不選
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
      {showImage && showImage.length > 0 && (
        <div className="warning-modal">
          <div className="warning-modal-content">
            <img src="your-image-url-here" alt="圖片" />
            <div className="warning-modal-buttons">
              <button type="button" onClick={() => setShowImage('')}>
                取消
              </button>
            </div>
          </div>
        </div>
      )}
      {images &&
        images.length > 0 &&
        images.map((image, index) => (
          <div
            key={Math.random()}
            role="button"
            tabIndex={0}
            onClick={() => handleReset()}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleReset();
              }
            }}
          >
            <img
              key={Math.random()}
              src={`data:image/jpg;base64,${image}`}
              alt=""
            />
          </div>
        ))}
    </div>
  );
};

export default OpenCtnrImgMtn;
